import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import isEqual from "lodash/isEqual";
import { getElement, getParentFormWidthChildren } from '@whalecloud/page-builder-core/selectors';
import { Table as DesignTable } from '@whalecloud/fdx';
import { ElementRoot } from '@whalecloud/page-builder-core/components/ElementRoot';
import Element from '@whalecloud/page-builder-core/components/Element';
import FormItem from '@whalecloud/page-builder-core/components/FormItem';
import { tableRegExp, calculateScrollWidth } from "@utils/util";
import HeaderCellRender from './HeaderCellRender';

const handleColumns = (props: any) => {
  const columnsRender: Array<any> = [];
  const columns: Array<any> = [];
  const { element, state, dropElement } = props;
  const { elements = [] } = element;
  elements.forEach((childId, index) => {
    const child = getElement(state, childId);
    columns.push({
      ...child.data.columnSettings,
    });
    // title渲染
    columnsRender.push({
      ...child.data.columnSettings,
      title: <HeaderCellRender index={index} element={element} child={child} dropElement={dropElement} />,
      render: (text, record, index) => {
        if (index === 0 && child.elements.length > 0) {
          return (
            <React.Fragment>
              <Element key={child.elements[0]} id={child.elements[0]} text={text} />
            </React.Fragment>
          );
        }
        return text;
      },
    });
  });
  return [columnsRender, columns];
};

const Table = (props: any) => {
  const { element, formElement } = props;
  const { formSettings, tableSettings = {}, settings = {}, className: styleClassName } = element.data;
  const { rules = [] } = formSettings;
  const { dataSource = [], scroll, rowSelection, hideLabel = false, ...restTableSettings } = tableSettings;
  const hideLabelProps = hideLabel ? { hideLabel : true } : {}
  const mounted = useRef();
  const [columnsRender, columns] = handleColumns(props);
  tableSettings.columns = columns;

  const [scrollWidth, setScrollWidth] = useState(0);

  const ruleProps: any = {};
  if (rules.length > 0) {
    ruleProps.rules = [{ required: rules[0].required, validator: (rule, value) => tableRegExp(rule, value, dataSource, rules[0]) }]
  }

  const handleResize = (len) => {
    setScrollWidth(calculateScrollWidth(formElement, element, len, false));
  }

  useEffect(() => {
    window.addEventListener('resize', () => handleResize(columnsRender.length));
    return () => {
      window.removeEventListener('resize', () => handleResize(columnsRender.length));
    }
  }, [scrollWidth]);

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      const timer = setTimeout(() => {
        handleResize(columnsRender.length);
        clearTimeout(timer);
      }, 0);
    } else {
      handleResize(columnsRender.length);
    }
  }, [columnsRender]);

  return (
    <ElementRoot element={element} elScrollWidth={scrollWidth}>
      {({ getAllClasses, elementStyle }) => {
        const className = getAllClasses('webiny-pb-base-page-element-style webiny-pb-page-element-table');
        return (
          <FormItem
            style={{
              ...elementStyle
            }}
            id={element.id}
            className={className}
            {...formSettings}
            {...ruleProps}
            {...hideLabelProps}
          >
            <DesignTable
              {...restTableSettings}
              rowSelection={rowSelection === false ? null : rowSelection}
              className={`${className} ${styleClassName}`}
              columns={columnsRender}
              dataSource={dataSource}
              scroll={{ x: (scroll && scroll.x) || scrollWidth || 0, y: (scroll && scroll.y) || 0 }}
            />
          </FormItem>
        )
      }}
    </ElementRoot>
  );
};

export default connect<any, any, any>(
  (state, props) => ({
    state,
    formElement: getParentFormWidthChildren(state, props.element.id)
  }),
  null,
  null,
  { areStatePropsEqual: isEqual }
)(Table);
